// extracted by mini-css-extract-plugin
export default {"replied_msg_preview":"styles_replied_msg_preview__iRB9i"};